import React, { useRef, useState } from "react";
import Slider from "react-slick";
import { Modal, Box } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Custom Arrow Components
const NextArrow = ({ onClick }) => (
  <div
    onClick={onClick}
    style={{
      position: "absolute",
      top: "16%",
      right: -24,
      zIndex: 2,
      cursor: "pointer",
      fontSize: "40px",
      color: "#333",
    }}
  >
    ❯
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div
    onClick={onClick}
    style={{
      position: "absolute",
      top: "16%",
      left: -24,
      zIndex: 2,
      cursor: "pointer",
      fontSize: "40px",
      color: "#333",
    }}
  >
    ❮
  </div>
);

const CarImageSlider = ({ images }) => {
  const slider1 = useRef(null);
  const slider2 = useRef(null);
  const [zoomImg, setZoomImg] = useState(null); // For modal zoom

  const mainSliderSettings = {
    asNavFor: slider2.current,
    ref: slider1,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
   
  };

  const thumbSliderSettings = {
    asNavFor: slider1.current,
    ref: slider2,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    centerMode: true,
    focusOnSelect: true,
    arrows: true,
    nextArrow: <NextArrow  />,
    prevArrow: <PrevArrow />,
  };

  const handleImageClick = (src) => {
    const fullSrc = src.startsWith("http") ? src : `/assets/carImages/${src}`;
    setZoomImg(fullSrc);
  };

  const handleClose = () => setZoomImg(null);

  return (
    <div style={{ maxWidth: "100%", margin: "0 auto", position: "relative" }}>
      {/* Main Slider */}
      <Slider {...mainSliderSettings}>
        {images.map((src, index) => {
          const fullSrc = src.startsWith("http") ? src : `/assets/carImages/${src}`;
          return (
            <div key={index}>
              <div className="zoom-container" onClick={() => handleImageClick(src)}>
                <img
                  src={fullSrc}
                  alt={`car-${index}`}
                  className="zoom-img"
                />
              </div>
            </div>
          );
        })}
      </Slider>

      {/* Thumbnail Slider */}
      <div style={{ marginTop: "15px" }}>
        <Slider {...thumbSliderSettings}>
          {images.map((src, index) => {
            const fullSrc = src.startsWith("http") ? src : `/assets/carImages/${src}`;
            return (
              <div key={index}>
                <img
                  src={fullSrc}
                  alt={`thumb-${index}`}
                  style={{
                    width: "100%",
                    height: "80px",
                    objectFit: "cover",
                    borderRadius: "5px",
                    padding: "5px",
                    cursor: "pointer",
                  }}
                />
              </div>
            );
          })}
        </Slider>
      </div>

      {/* Zoom Modal */}
      <Modal open={!!zoomImg} onClose={handleClose}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            bgcolor: "rgba(0,0,0,0.9)",
          }}
        >
          <img
            src={zoomImg}
            alt="Zoomed"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              objectFit: "contain",
              borderRadius: "10px",
            }}
            onClick={handleClose}
          />
        </Box>
      </Modal>

      {/* Zoom Hover Style */}
      <style>
        {`
          .zoom-container {
            overflow: hidden;
            border-radius: 10px;
            cursor: zoom-in;
          }

          .zoom-img {
            width: 100%;
            height: auto;
            transition: transform 0.4s ease;
          }

          .zoom-container:hover .zoom-img {
            transform: scale(1.1);
          }
        `}
      </style>
    </div>
  );
};

export default CarImageSlider;
